import React, { Component, Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withSnackbar } from "notistack";
import clsx from "clsx";
import {
  makeStyles,
  withStyles,
  Stepper,
  Button,
  Step,
  StepLabel,
  MenuItem,
  Select,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormLabel,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import {
  Image as ImageIcon,
  VpnKey as VpnKeyIcon,
  PersonAdd as PersonAddIcon,
  MonetizationOn as MonetizationOnIcon,
  Update as UpdateIcon,
} from "@material-ui/icons";

import {
  ACTION_RENEW,
  approveRenewalBrand,
  approveRenewalOwners,
  confirmRenewalUser,
  getRenewal,
  leavingSiteFrom,
  renewalContinueToPay,
  updateRenewalStatus,
  confirmRenewalCheckoutSuccess,
  hasItems,
  replaceAt,
  _empty,
  getProducts,
  approveRenewalPeriodSelection,
} from "util/APIUtils";
import { selectUser } from "selectors/user";
import { PRODUCTS, RENEWAL_STATUSES } from "common/constants";
import LoadingIndicator from "components/LoadingIndicator";
import Brand from "components/brandListItem";
import ContactInformation from "components/contactInformation";
import ContactTheBrandRecorder from "components/contactBrandRecorder";
import LoginPlaceholder from "components/loginPlaceholder";
import Invoice from "./components/Invoice";
import Checkout from "./components/Checkout";
import { Link } from "react-router-dom";

const beginning = (status) => status === RENEWAL_STATUSES.STARTED;
const selectOwners = (status, user) =>
  (status === RENEWAL_STATUSES.BRAND_APPROVED && user) ||
  status === RENEWAL_STATUSES.LOGIN_ATTACHED;

const selectRenewalPeriod = (status, user) =>
  status === RENEWAL_STATUSES.RENEWAL_PERIOD_SELECTION ||
  status === RENEWAL_STATUSES.OWNERSHIP_APPROVED ||
  status === RENEWAL_STATUSES.ADDED_MULTIPLE_BANDS;

const displayInvoice = (status) =>
  // status === RENEWAL_STATUSES.OWNERSHIP_APPROVED ||
  // status === RENEWAL_STATUSES.ADDED_MULTIPLE_BANDS ||
  status === RENEWAL_STATUSES.RENEWAL_PERIOD_CHANGED ||
  status === RENEWAL_STATUSES.CONTINUED_TO_PAY ||
  status === RENEWAL_STATUSES.CANCELED_ON_PAY_SCREEN;
const needsLogin = (status) => status === RENEWAL_STATUSES.LOGIN_NEEDED;
const displayReceipt = (status) =>
  status === RENEWAL_STATUSES.PRESENT_RECEIPT ||
  status === RENEWAL_STATUSES.RECEIPT_PRESENTED;

class Renew extends Component {
  constructor(props) {
    super(props);
    this.steps = ["Brand", "Login", "Owner", "Renewal Period", "Pay"];
  }

  _isMounted = false;

  state = {
    renewal: null,
    owner: null,
    owners: null,
    activeStep: 0,
    loading: false,
    openDialog: false,
    error: null,
    renewalProductOptions: null,
    renewalProduct: null,
  };

  /*
    staus ===  RENEWAL_STATUSES.STARTED ==> activeStep = 0

    status === RENEWAL_STATUSES.LOGIN_NEEDED ==> activeStep = 1
     
    status === RENEWAL_STATUSES.BRAND_APPROVED ||
    status === RENEWAL_STATUSES.LOGIN_ATTACHED  ==> activeStep = 2

    status === RENEWAL_STATUSES.RENEWAL_PERIOD_SELECTION ||
    status === RENEWAL_STATUSES.OWNERSHIP_APPROVED ||
    status === RENEWAL_STATUSES.ADDED_MULTIPLE_BANDS  ==> activeStep = 3

    status === RENEWAL_STATUSES.RENEWAL_PERIOD_CHANGED ||
    status === RENEWAL_STATUSES.CONTINUED_TO_PAY ||
    status === RENEWAL_STATUSES.CANCELED_ON_PAY_SCREEN  ==> activeStep = 4
  */

  componentDidMount() {
    this._isMounted = true;
    this.loadProducts();
    this.validateRenewal();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user && this.props.user) {
      this.validateRenewal();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  validateRenewal = () => {
    const {
      location: { state },
      user,
    } = this.props;
    const existingRenewal =
      state && state.renewal
        ? state.renewal
        : state && state.from && state.from.state && state.from.state.renewal;

    if (existingRenewal && user) {
      if (existingRenewal.status === RENEWAL_STATUSES.LOGIN_NEEDED) {
        this.confirmCurrentUser(existingRenewal, user);
      } else if (existingRenewal.status === RENEWAL_STATUSES.CONTINUED_TO_PAY) {
        this.confirmPayment(existingRenewal, state.token);
      } else {
        this.updateRenewalState(existingRenewal);
        // update renewalProduct
        this.updateRenewalProduct(existingRenewal);
      }
    } else {
      this.loadRenewal();
    }
  };

  loadRenewal = () => {
    const {
      location,
      history,
      match: {
        params: { brandHash, pinHash },
      },
    } = this.props;
    this.setState({ loading: true });
    getRenewal(brandHash, pinHash, location.search)
      .then((returnedRenewal) => {
        if (this._isMounted) {
          if (!location.search) {
            history.replace({
              pathname: location.pathname,
              search: "?id=" + returnedRenewal.id,
            });
          }
          this.updateRenewalState(returnedRenewal);
          // also set initial state for renewalProduct
          this.updateRenewalProduct(returnedRenewal);
          // set Current Step
          this.setActiveStep(this.getCurrentStep(returnedRenewal));
        }
      })
      .catch((error) => {
        if (this._isMounted) {
          this.loadingDone();
          this.props.enqueueSnackbar(
            (error && error.message) ||
              "Oops! Something went wrong. Please try again!",
            { variant: "error" }
          );
        }
      });
  };

  handleBack = () => {
    if (this.state.activeStep > 0) {
      this.setActiveStep(this.state.activeStep - 1);
    }
  };

  loadingDone = () => {
    this.setState({ loading: false });
  };

  updateRenewalState = (newRenewal) => {
    const {
      initialBrand: { brandOwners: owners },
    } = newRenewal;
    const owner = owners && owners.length > 0 && owners[0];
    if (owner) {
      if (_empty(owner.emails)) {
        owner.emails = [{ email: "" }];
      }
    }

    this.setState({
      renewal: newRenewal,
      owner: owner,
      owners: owners,
      loading: false,
      error: null,
    });
  };

  setActiveStep = (nextStep) => {
    this.setState({ activeStep: nextStep });
  };

  getCurrentStep = (returnedRenewal) => {
    let currentStep = 0;
    const status = returnedRenewal && returnedRenewal.status;

    if (status === RENEWAL_STATUSES.STARTED) {
      currentStep = 0;
    } else if (status === RENEWAL_STATUSES.LOGIN_NEEDED) {
      currentStep = 1;
    } else if (
      status === RENEWAL_STATUSES.BRAND_APPROVED ||
      status === RENEWAL_STATUSES.LOGIN_ATTACHED
    ) {
      currentStep = 2;
    } else if (
      status === RENEWAL_STATUSES.RENEWAL_PERIOD_SELECTION ||
      status === RENEWAL_STATUSES.OWNERSHIP_APPROVED ||
      status === RENEWAL_STATUSES.ADDED_MULTIPLE_BANDS
    ) {
      currentStep = 3;
    } else if (
      status === RENEWAL_STATUSES.RENEWAL_PERIOD_CHANGED ||
      status === RENEWAL_STATUSES.CONTINUED_TO_PAY ||
      status === RENEWAL_STATUSES.CANCELED_ON_PAY_SCREEN
    ) {
      currentStep = 4;
    }

    return currentStep;
  };

  setCurrentStep = (returnedRenewal) => {
    const currentStep = this.getCurrentStep(returnedRenewal);
    this.setActiveStep(currentStep);
  };

  handleSuccess = (returnedRenewal) => {
    //this.incrementStep();
    this.setCurrentStep(returnedRenewal);
    this.updateRenewalState(returnedRenewal);
  };

  handleError = (error) => {
    this.loadingDone();
    this.props.enqueueSnackbar(
      (error && error.message) ||
        "Oops! Something went wrong. Please try again!",
      { variant: "error" }
    );
  };

  approveBrand = () => {
    const {
      renewal: { id: renewalId, initialBrand },
    } = this.state;

    approveRenewalBrand(renewalId, initialBrand.id)
      .then(this.handleSuccess)
      .catch(this.handleError);
  };

  confirmCurrentUser = (renewal, user) => {
    confirmRenewalUser(renewal.id, user.id)
      .then(this.handleSuccess)
      .catch(this.handleError);
  };

  confirmPayment = (renewal, token) => {
    confirmRenewalCheckoutSuccess(renewal.id, token)
      .then((returnedRenewal) => {
        this.handleSuccess(returnedRenewal);
        if (returnedRenewal.status === RENEWAL_STATUSES.PRESENT_RECEIPT) {
          updateRenewalStatus(
            returnedRenewal.id,
            RENEWAL_STATUSES.RECEIPT_PRESENTED
          );
        }
      })
      .catch(this.handleError);
  };

  approveOwners = () => {
    const {
      renewal: { id },
      owner,
      owners,
    } = this.state;
    approveRenewalOwners(id, owner, owners)
      .then(this.handleSuccess)
      .catch(this.handleError);
  };

  pay = () => {
    renewalContinueToPay(this.state.renewal.id)
      .then((response) => {
        this.handleSuccess(response.renewal);
        leavingSiteFrom(
          this.props.location,
          Object.assign({}, this.state, {
            action: ACTION_RENEW,
            renewalId: response.renewal.id,
            token: response.token,
          })
        );
        window.location.href = response.checkoutUrl;
      })
      .catch((response) => {
        this.loadingDone();
        // console.log("error", response);
        this.setState({ error: response.message });
      });
  };

  goToMyBrands = () => {
    this.props.history.replace("/my-brands");
  };

  backToBrand = () => {
    this.updateStatus(RENEWAL_STATUSES.STARTED);
  };

  updateStatus = (newStatus) => {
    updateRenewalStatus(this.state.renewal.id, newStatus)
      .then(this.handleSuccess)
      .catch(this.handleError);
  };

  setOwner = (newOwner) => {
    if (newOwner) {
      if (_empty(newOwner.emails)) {
        newOwner.emails = [{ email: "" }];
      }
    }
    this.setState({
      owner: newOwner,
      owners: replaceAt(this.state.owners, newOwner),
    });
  };

  setOpenDialog = (dialogState) => {
    this.setState({ openDialog: dialogState });
  };

  handleDialogClose = () => {
    this.setOpenDialog(false);
  };

  loadProducts = () => {
    var renewalProductOptionsList = getProducts()
      .then((renewalProductList) => {
        if (renewalProductList && renewalProductList.length > 0) {
          var lst = renewalProductList.filter((record) => {
            return (
              record.product === "BRAND_RENEWAL_FIVE_YEAR_TERM" ||
              record.product === "BRAND_RENEWAL_TEN_YEAR_TERM"
            );
          });
          this.setState({
            renewalProductOptions: lst,
          });

          return lst;
        }
      })
      .catch(this.handleError);
  };

  updateRenewalProduct = (returnedRenewal) => {
    const productDetailItem =
      returnedRenewal &&
      returnedRenewal.order &&
      returnedRenewal.order.items &&
      returnedRenewal.order.items.length &&
      returnedRenewal.order.items.length > 0 &&
      returnedRenewal.order.items[0];

    const renewalProductOfFirstOrderLineItem =
      productDetailItem && productDetailItem.product;

    if (this.state.renewalProduct !== renewalProductOfFirstOrderLineItem) {
      this.setRenewalProduct(renewalProductOfFirstOrderLineItem);
    }
  };

  handleRenewalProductChange = (updatedRenewalProduct) => {
    this.setRenewalProduct(updatedRenewalProduct);
  };

  setRenewalProduct = (updatedRenewalProduct) => {
    this.setState({ renewalProduct: updatedRenewalProduct });
  };

  approveRenewalPeriodSelection = () => {
    const { renewal, renewalProductOptions, renewalProduct } = this.state;

    // get product record
    const renewalProductDetails = renewalProductOptions.filter((renPrd) => {
      return renPrd.product == renewalProduct;
    });

    if (
      renewalProductDetails == undefined ||
      renewalProductDetails == null ||
      renewalProductDetails.length == 0
    ) {
      return;
    }

    const renewalId = renewal.id;
    const orderId = renewal.order.id;

    approveRenewalPeriodSelection(renewalId, orderId, renewalProductDetails[0])
      .then(this.handleSuccess)
      .catch(this.handleError);
  };

  backToOwners = () => {
    updateRenewalStatus(this.state.renewal.id, RENEWAL_STATUSES.BRAND_APPROVED)
      .then((returnedRenewal) => {
        this.updateRenewalState(returnedRenewal);
        this.handleBack();
      })
      .catch(this.handleError);
  };

  backToRenewalPerdiodSelection = () => {
    updateRenewalStatus(
      this.state.renewal.id,
      RENEWAL_STATUSES.RENEWAL_PERIOD_SELECTION
    )
      .then((returnedRenewal) => {
        this.updateRenewalState(returnedRenewal);
        this.handleBack();
      })
      .catch(this.handleError);
  };

  render() {
    const {
      renewal,
      loading,
      activeStep,
      owner,
      owners,
      error,
      renewalProductOptions,
      renewalProduct,
    } = this.state;
    const status = renewal && renewal.status;
    const steps = this.steps;

    const noOrder = renewal && hasItems(renewal.order);
    const { classes, enqueueSnackbar } = this.props;

    return loading ? (
      <LoadingIndicator />
    ) : (
      <div className={classes.root}>
        <div className={classes.container}>
          <div className={classes.card}>
            {/* <h2>Brand Renewals are closed.</h2>
            <p>Next Renewal Period is in 2025.</p>
            <p>
              <Link to="/help/brandRecorder">Contact the Brand Recorder</Link>{" "}
              for more information. 
            </p>
            */}
            <div className={classes.stepperRoot}>
              <Stepper className={classes.stepper} activeStep={activeStep}>
                {steps.map((label) => {
                  const stepProps = {};
                  const labelProps = {};
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel
                        className={classes.stepLabel}
                        StepIconComponent={StepIcons}
                        {...labelProps}
                      >
                        {label}
                      </StepLabel>
                    </Step>
                  );
                })}
              </Stepper>

              <div>
                {activeStep === steps.length ? (
                  <div>
                    <LoadingIndicator />
                  </div>
                ) : (
                  <div className={classes.step}>
                    {error && <div className="error">{error}</div>}
                    {beginning(status) && (
                      <div className="brands">
                        {renewal && renewal.initialBrand ? (
                          <Brand
                            brand={renewal.initialBrand}
                            hideButtons={true}
                            enqueueSnackbar={enqueueSnackbar}
                          />
                        ) : (
                          <span>Brand not found</span>
                        )}
                        <Buttons
                          label="That's My Brand"
                          handleNext={this.approveBrand}
                          setOpenDialog={this.setOpenDialog}
                          classes={classes}
                        />
                      </div>
                    )}

                    {needsLogin(status) && (
                      <LoginPlaceholder title="Account is required to proceed" />
                    )}

                    {selectOwners(status, this.props.user) && (
                      <div className={classes.container}>
                        <ConfirmOwnership
                          classes={classes}
                          handleOwnerChange={this.setOwner}
                          owner={owner}
                          owners={owners}
                          enqueueSnackbar={enqueueSnackbar}
                          setOpenDialog={this.setOpenDialog}
                        />
                        <Buttons
                          label="Looks Good"
                          handleBack={this.backToBrand}
                          handleNext={this.approveOwners}
                          setOpenDialog={this.setOpenDialog}
                          classes={classes}
                        ></Buttons>
                      </div>
                    )}
                    {selectRenewalPeriod(status, this.props.user) && (
                      <div className={classes.container}>
                        <ConfirmRenewalPeriod
                          classes={classes}
                          renewalProductOptions={renewalProductOptions}
                          renewalProduct={renewalProduct}
                          handleRenewalProductChange={
                            this.handleRenewalProductChange
                          }
                          enqueueSnackbar={enqueueSnackbar}
                          setOpenDialog={this.setOpenDialog}
                        />
                        <Buttons
                          label="Continue"
                          handleBack={this.backToOwners}
                          handleNext={this.approveRenewalPeriodSelection}
                          setOpenDialog={this.setOpenDialog}
                          classes={classes}
                        ></Buttons>
                      </div>
                    )}
                    {displayInvoice(status) && (
                      <div className={classes.container}>
                        {renewal && renewal.order && (
                          <Checkout
                            initiatingBrand={renewal.initialBrand}
                            order={renewal.order}
                            updateInvoice={this.loadRenewal}
                            enqueueSnackbar={enqueueSnackbar}
                          >
                            <Buttons
                              label="Pay"
                              disablePrimary={noOrder}
                              // handleBack={this.handleBack}
                              handleBack={this.backToRenewalPerdiodSelection}
                              handleNext={this.pay}
                              setOpenDialog={this.setOpenDialog}
                              classes={classes}
                            ></Buttons>
                          </Checkout>
                        )}
                      </div>
                    )}

                    {displayReceipt(status) && (
                      <div className={classes.container}>
                        {renewal && renewal.order ? (
                          <Invoice paid={true} order={renewal.order} />
                        ) : (
                          <span>Order not found</span>
                        )}
                        <Buttons
                          label="Show me my Brands"
                          handleNext={this.goToMyBrands}
                          setOpenDialog={this.setOpenDialog}
                          classes={classes}
                        ></Buttons>
                      </div>
                    )}

                    <Dialog
                      open={this.state.openDialog}
                      onClose={this.handleDialogClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle
                        className={classes.dialogContent}
                        id="alert-dialog-title"
                      >
                        {"Get help quick!"}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText
                          id="alert-dialog-description"
                          className={classes.dialogContent}
                        >
                          <ContactTheBrandRecorder inDialog={true} />
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={this.handleDialogClose}
                          color="primary"
                          autoFocus
                        >
                          close
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function Buttons({
  label,
  disablePrimary,
  handleNext,
  classes,
  children,
  handleBack,
  setOpenDialog,
}) {
  return (
    <div className={classes.buttonBar}>
      <Button
        disabled={!handleBack}
        onClick={handleBack}
        className={classes.button}
      >
        Back
      </Button>
      {children}
      <Button
        variant="contained"
        color="primary"
        disabled={!!disablePrimary}
        onClick={handleNext}
        className={classes.button}
      >
        {label}
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setOpenDialog(true)}
        className={classes.button}
      >
        Help
      </Button>
    </div>
  );
}

const useColorlibStepIconStyles = makeStyles({
  root: {
    zIndex: 1,
    color: "#999",
    width: 30,
    height: 30,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    paddingLeft: "8px",
  },
  active: {
    color: "#27783F",
  },
  completed: {
    color: "#27783F",
  },
  logo: {
    width: 30,
  },
});

function StepIcons(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <ImageIcon />,
    2: <VpnKeyIcon />,
    3: <PersonAddIcon />,
    4: <UpdateIcon />,
    5: <MonetizationOnIcon />,
  };
  return (
    <div
      className={clsx(
        classes.root,
        {
          [classes.active]: active,
          [classes.completed]: completed,
        },
        classes.icon
      )}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

function ConfirmRenewalPeriod({
  renewalProductOptions,
  renewalProduct,
  handleRenewalProductChange,
  classes,
}) {
  return renewalProductOptions && renewalProductOptions.length > 0 ? (
    <div className={classes.step3}>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="renwalOptions"
          name="renewalOptions"
          value={renewalProduct}
          onChange={(e) => {
            handleRenewalProductChange(e.target.value);
          }}
          row
        >
          {renewalProductOptions.map((renPrd) => {
            return (
              <FormControlLabel
                value={renPrd.product}
                control={<Radio />}
                label={renPrd.description}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  ) : (
    <div className={classes.step3}>No data</div>
  );
}

function ConfirmOwnership({
  owner,
  owners,
  handleOwnerChange,
  classes,
  setOpenDialog,
}) {
  return (
    <div className={classes.step2}>
      <ChooseOwner
        setOpenDialog={setOpenDialog}
        owner={owner}
        owners={owners}
        handleOwnerChange={handleOwnerChange}
      />
      <ContactInformation
        displayEditButton={true}
        owner={owner}
        handleOwnerChange={handleOwnerChange}
        displayEmail={true}
      />
    </div>
  );
}

const useChooseOwnerStyles = makeStyles(() => ({
  formControl: {
    marginBottom: 10,
  },
  nameMenuItem: {
    padding: 0,
    margin: 0,
  },
  noseeum: {
    color: "#f00",
  },
  notMe: {
    margin: 3,
    padding: "0 8px",
  },
}));

function ChooseOwner({ owner, owners, handleOwnerChange, setOpenDialog }) {
  const classes = useChooseOwnerStyles();
  const [open, setOpen] = React.useState(false);
  const [selectedOwner, setSelectedOwner] = React.useState(owner.id);

  const handleChange = ({ target: { value: ownerId } }) => {
    if (ownerId === 0) {
      setOpenDialog(true);
      return;
    }
    setSelectedOwner(ownerId);
    const newOwner = owners.find((thisOwner) => thisOwner.id === ownerId);
    if (newOwner) {
      handleOwnerChange(newOwner);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <FormControl className={classes.formControl}>
        {owner && (
          <Select
            id="selected-owner-name"
            size="small"
            IconComponent={() => (
              <Button
                className={classes.notMe}
                size="small"
                variant="contained"
                onClick={handleOpen}
              >
                &nbsp;not&nbsp;me?&nbsp;
              </Button>
            )}
            value={selectedOwner}
            onChange={handleChange}
            open={open}
            onClose={handleClose}
            onOpen={handleOpen}
          >
            {owners.map((thisOwner) => (
              <MenuItem
                className={classes.nameMenuItem}
                key={thisOwner.id}
                value={thisOwner.id}
              >
                {thisOwner.firstName} {thisOwner.lastName}
              </MenuItem>
            ))}
            <MenuItem className={classes.noseeum} key="0" value={0}>
              I don&apos;t see my name
            </MenuItem>
          </Select>
        )}
      </FormControl>
      <br />
    </Fragment>
  );
}

const styles = () => ({
  root: {
    backgroundColor: "#FAFAFB",
    maxWidth: "1100px",
    display: "flex",
    margin: "0 auto",
    justifyContent: "space-around",
  },
  container: {
    "& .login-content": {
      padding: "3.5em 0 1.5em",
    },
    "& .brands > .MuiCard-root": {
      padding: "1.5em",
      display: "flex",
    },
    "& .brands > .MuiCard-root > div": {
      margin: "auto",
    },
    "& .invoice": {
      maxWidth: "500px",
      margin: "auto",
    },
    maxWidth: "800px",
    width: "100%",
  },
  card: {
    textAlign: "center",
    padding: "2em",
    margin: "0 auto",
  },
  header: {
    width: 80,
    height: 158,
  },
  step2: {
    margin: "20px auto",
    maxWidth: 260,
  },
  dialogContent: {
    textAlign: "center",
  },

  stepperRoot: {
    width: "100%",
  },
  stepper: {
    backgroundColor: "#FAFAFB",
    padding: 0,
  },
  stepLabel: {
    display: "block",
    textAlign: "center",
    color: "#27783F",
  },
  button: {
    marginRight: 8,
  },
  slash: {
    display: "inline-block",
    fontSize: "2em",
    padding: "0 8px",
  },
  brandHash: {
    marginLeft: 30,
    padding: 0,
    width: 100,
  },
  pinHash: {
    padding: 0,
    width: 70,
  },
  instructions: {
    padding: "20px",
  },
  step: {
    margin: "20px auto",
  },
  addAnotherContainer: {
    textAlign: "right",
    padding: "20px 10px 0",
  },
  buttonBar: {
    margin: "20px auto",
    textAlign: "center",
  },
});

const withConnect = connect(
  createStructuredSelector({
    user: selectUser,
  })
);

export default compose(withConnect, withSnackbar, withStyles(styles))(Renew);
